import {
  createFormatterDataModel,
  IBooleanFormatConfig,
  IFormatterDataModel,
} from '../../data-models/formatter.data-model';

export enum BooleanFormatterId {
  yesNo = 'yesNo',
  trueFalse = 'trueFalse',
}

export const BooleanFormattersConfig: Record<
  BooleanFormatterId,
  IFormatterDataModel<IBooleanFormatConfig>
> = {
  yesNo: createFormatterDataModel({
    id: 'yesNo',
    config: { falseValue: 'No', trueValue: 'Yes', noValue: 'N/A' },
    type: 'boolean',
  }),
  trueFalse: createFormatterDataModel({
    id: 'trueFalse',
    config: {
      falseValue: 'false',
      trueValue: 'true',
      noValue: '',
    },
    type: 'boolean',
  }),
};
